import { API } from ".";

export const GET_UNIT_STORM_OPERATION_REQUEST =
  "@@unit/GET_UNIT_STORM_OPERATION_REQUEST";
export const GET_UNIT_STORM_OPERATION_SUCCESS =
  "@@unit/GET_UNIT_STORM_OPERATION_SUCCESS";
export const GET_UNIT_STORM_OPERATION_FAILURE =
  "@@unit/GET_UNIT_STORM_OPERATION_FAILURE";

export function getunitStormOperation(id, operationId) {
  if (!id) return;
  return async (dispatch) => {
    dispatch({
      type: GET_UNIT_STORM_OPERATION_REQUEST,
    });
    try {
      const response = await API.get(
        "cmsAPI",
        `/unit/${id}/operation/${operationId}`
      );
      dispatch({
        type: GET_UNIT_STORM_OPERATION_SUCCESS,
        payload: response,
      });
      dispatch(setUnitStormOperationLoadState(""));
    } catch (error) {
      dispatch({
        type: GET_UNIT_STORM_OPERATION_FAILURE,
        payload: error,
      });
    }
  };
}

export const CREATE_UNIT_STORM_OPERATION_REQUEST =
  "@@unit/CREATE_UNIT_STORM_OPERATION_REQUEST";
export const CREATE_UNIT_STORM_OPERATION_SUCCESS =
  "@@unit/CREATE_UNIT_STORM_OPERATION_SUCCESS";
export const CREATE_UNIT_STORM_OPERATION_FAILURE =
  "@@unit/CREATE_UNIT_STORM_OPERATION_FAILURE";

export function createunitStormOperation(id, data, callback) {
  if (!id) return;
  return async (dispatch) => {
    dispatch({
      type: CREATE_UNIT_STORM_OPERATION_REQUEST,
    });
    try {
      const init = {
        body: data,
      };
      const response = await API.post("cmsAPI", `/unit/${id}/operation`, init);

      dispatch({
        type: CREATE_UNIT_STORM_OPERATION_SUCCESS,
        payload: response,
      });

      dispatch(setUnitStormOperationLoadState("starting"));

      if (callback) {
        callback();
      }
    } catch (error) {
      dispatch({
        type: CREATE_UNIT_STORM_OPERATION_FAILURE,
        payload: error,
      });
    }
  };
}

export const DELETE_UNIT_STORM_OPERATION_REQUEST =
  "@@unit/DELETE_UNIT_STORM_OPERATION_REQUEST";
export const DELETE_UNIT_STORM_OPERATION_SUCCESS =
  "@@unit/DELETE_UNIT_STORM_OPERATION_SUCCESS";
export const DELETE_UNIT_STORM_OPERATION_FAILURE =
  "@@unit/DELETE_UNIT_STORM_OPERATION_FAILURE";

export function deleteunitStormOperation(id, operationId, callback) {
  if (!id) return;
  return async (dispatch) => {
    dispatch({
      type: DELETE_UNIT_STORM_OPERATION_REQUEST,
    });
    try {
      const response = await API.del(
        "cmsAPI",
        `/unit/${id}/operation/${operationId}`
      );
      dispatch({
        type: DELETE_UNIT_STORM_OPERATION_SUCCESS,
        payload: response,
      });

      dispatch(setUnitStormOperationLoadState("stopping"));

      if (callback) {
        callback();
      }
    } catch (error) {
      dispatch({
        type: DELETE_UNIT_STORM_OPERATION_FAILURE,
        payload: error,
      });
    }
  };
}

export const CLEAR_UNIT_STORM_OPERATION = "@@unit/CLEAR_UNIT_STORM_OPERATION";

export function clearunitStormOperation() {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_UNIT_STORM_OPERATION,
    });
  };
}

//EVBOOST

export const GET_UNIT_EVBOOST_OPERATION_REQUEST =
  "@@unit/GET_UNIT_EVBOOST_OPERATION_REQUEST";
export const GET_UNIT_EVBOOST_OPERATION_SUCCESS =
  "@@unit/GET_UNIT_EVBOOST_OPERATION_SUCCESS";
export const GET_UNIT_EVBOOST_OPERATION_FAILURE =
  "@@unit/GET_UNIT_EVBOOST_OPERATION_FAILURE";

export function getunitEvBoostOperation(id, operationId) {
  if (!id) return;
  return async (dispatch) => {
    dispatch({
      type: GET_UNIT_EVBOOST_OPERATION_REQUEST,
    });
    try {
      const response = await API.get(
        "cmsAPI",
        `/unit/${id}/operation/${operationId}`
      );
      dispatch({
        type: GET_UNIT_EVBOOST_OPERATION_SUCCESS,
        payload: response,
      });
      dispatch(setUnitEvboostOperationLoadState(""));
    } catch (error) {
      dispatch({
        type: GET_UNIT_EVBOOST_OPERATION_FAILURE,
        payload: error,
      });
    }
  };
}

export const CREATE_UNIT_EVBOOST_OPERATION_REQUEST =
  "@@unit/CREATE_UNIT_EVBOOST_OPERATION_REQUEST";
export const CREATE_UNIT_EVBOOST_OPERATION_SUCCESS =
  "@@unit/CREATE_UNIT_EVBOOST_OPERATION_SUCCESS";
export const CREATE_UNIT_EVBOOST_OPERATION_FAILURE =
  "@@unit/CREATE_UNIT_EVBOOST_OPERATION_FAILURE";

export function createunitEvBoostOperation(id, data, callback) {
  if (!id) return;
  return async (dispatch) => {
    dispatch({
      type: CREATE_UNIT_EVBOOST_OPERATION_REQUEST,
    });
    try {
      const init = {
        body: data,
      };
      const response = await API.post("cmsAPI", `/unit/${id}/operation`, init);

      dispatch({
        type: CREATE_UNIT_EVBOOST_OPERATION_SUCCESS,
        payload: response,
      });

      if (data.ev1_charger === "boost") {
        dispatch(setUnitEvboostOperationLoadState("starting"));
      }

      if (callback) {
        callback();
      }
    } catch (error) {
      dispatch({
        type: CREATE_UNIT_EVBOOST_OPERATION_FAILURE,
        payload: error,
      });
    }
  };
}

export const DELETE_UNIT_EVBOOST_OPERATION_REQUEST =
  "@@unit/DELETE_UNIT_EVBOOST_OPERATION_REQUEST";
export const DELETE_UNIT_EVBOOST_OPERATION_SUCCESS =
  "@@unit/DELETE_UNIT_EVBOOST_OPERATION_SUCCESS";
export const DELETE_UNIT_EVBOOST_OPERATION_FAILURE =
  "@@unit/DELETE_UNIT_EVBOOST_OPERATION_FAILURE";

export function deleteunitEvBoostOperation(id, operationId, callback) {
  if (!id) return;
  return async (dispatch) => {
    dispatch({
      type: DELETE_UNIT_EVBOOST_OPERATION_REQUEST,
    });
    try {
      const response = await API.del(
        "cmsAPI",
        `/unit/${id}/operation/${operationId}`
      );
      dispatch({
        type: DELETE_UNIT_EVBOOST_OPERATION_SUCCESS,
        payload: response,
      });

      dispatch(setUnitEvboostOperationLoadState("stopping"));

      if (callback) {
        callback();
      }
    } catch (error) {
      dispatch({
        type: DELETE_UNIT_EVBOOST_OPERATION_FAILURE,
        payload: error,
      });
    }
  };
}

export const CLEAR_UNIT_EVBOOST_OPERATION =
  "@@unit/CLEAR_UNIT_EVBOOST_OPERATION";

export function clearunitEvBoostOperation() {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_UNIT_EVBOOST_OPERATION,
    });
  };
}

export const SET_UNIT_STORM_OPERATION_LOAD_STATE =
  "@@unit/SET_UNIT_STORM_OPERATION_LOAD_STATE";

export function setUnitStormOperationLoadState(value) {
  return async (dispatch) => {
    dispatch({
      type: SET_UNIT_STORM_OPERATION_LOAD_STATE,
      payload: value,
    });
  };
}

export const SET_UNIT_EVBOOST_OPERATION_LOAD_STATE =
  "@@unit/SET_UNIT_EVBOOST_OPERATION_LOAD_STATE";

export function setUnitEvboostOperationLoadState(value) {
  return async (dispatch) => {
    dispatch({
      type: SET_UNIT_EVBOOST_OPERATION_LOAD_STATE,
      payload: value,
    });
  };
}

export const GET_SETTINGS_STORM_OPERATION_REQUEST =
  "@@unit/GET_SETTINGS_STORM_OPERATION_REQUEST";
export const GET_SETTINGS_STORM_OPERATION_SUCCESS =
  "@@unit/GET_SETTINGS_STORM_OPERATION_SUCCESS";
export const GET_SETTINGS_STORM_OPERATION_FAILURE =
  "@@unit/GET_SETTINGS_STORM_OPERATION_FAILURE";

export function getSettingsStormOperation(id) {
  if (!id) return;
  return async (dispatch) => {
    dispatch({
      type: GET_SETTINGS_STORM_OPERATION_REQUEST,
    });
    try {
      const response = await API.get("cmsAPI", `/unit/${id}/operation`);
      dispatch({
        type: GET_SETTINGS_STORM_OPERATION_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_SETTINGS_STORM_OPERATION_FAILURE,
        payload: error,
      });
    }
  };
}

export const GET_SETTINGS_EVBOOST_OPERATION_REQUEST =
  "@@unit/GET_SETTINGS_EVBOOST_OPERATION_REQUEST";
export const GET_SETTINGS_EVBOOST_OPERATION_SUCCESS =
  "@@unit/GET_SETTINGS_EVBOOST_OPERATION_SUCCESS";
export const GET_SETTINGS_EVBOOST_OPERATION_FAILURE =
  "@@unit/GET_SETTINGS_EVBOOST_OPERATION_FAILURE";

export function getSettingsEvBoostOperation(id) {
  if (!id) return;
  return async (dispatch) => {
    dispatch({
      type: GET_SETTINGS_EVBOOST_OPERATION_REQUEST,
    });
    try {
      const response = await API.get("cmsAPI", `/unit/${id}/operation`);
      dispatch({
        type: GET_SETTINGS_EVBOOST_OPERATION_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_SETTINGS_EVBOOST_OPERATION_FAILURE,
        payload: error,
      });
    }
  };
}
